import React, { useState } from 'react';
import RecoveryPasswordForm from './RecoveryPasswordForm';
import ChangePasswordForm from './ChangePasswordForm';
import logo_monere from '../../../assets/images/logo_monere.png';
import './RecoveryPassword.css';

const RecoveryPassword = () => {
    const [showChangePasswordForm, setShowChangePasswordForm] = useState(false);
    const [successPassword, setSuccessPassword] = useState(false);
    // El código de recuperación va atado al correo al que se envió
    const [recoveryEmail, setRecoveryEmail] = useState('');

    return (
        <div className="recovery-container">
            <div className="recovery-background">
                <div className="recovery-background-pattern"></div>
            </div>

            <div className="recovery-content">
                <div className="recovery-card">
                    <div className="recovery-header">
                        <div className="recovery-logo">
                            <img src={logo_monere} alt="Monere" />
                        </div>
                        <h1 className="recovery-title">
                            {showChangePasswordForm ? 'Nueva Contraseña' : 'Recuperar Contraseña'}
                        </h1>
                        <p className="recovery-subtitle">
                            {showChangePasswordForm 
                                ? 'Ingrese su código de verificación y nueva contraseña'
                                : 'Ingrese su correo electrónico para recibir un código de verificación'
                            }
                        </p>
                    </div>

                    <div className="recovery-body">
                        {showChangePasswordForm ? (
                            successPassword ? (
                                <div className="recovery-success">
                                    <div className="success-icon">
                                        <i className="fas fa-check-circle"></i>
                                    </div>
                                    <h3>¡Contraseña actualizada!</h3>
                                    <p>Su contraseña ha sido cambiada correctamente.</p>
                                    <a href="/login" className="btn-recovery">
                                        <span>Iniciar Sesión</span>
                                        <i className="fas fa-arrow-right"></i>
                                    </a>
                                </div>
                            ) : (
                                <ChangePasswordForm
                                    email={recoveryEmail}
                                    setChangePassword={setSuccessPassword}
                                />
                            )
                        ) : (
                            <RecoveryPasswordForm
                                setSendEmail={(show: boolean, email: string) => {
                                    setRecoveryEmail(email);
                                    setShowChangePasswordForm(show);
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecoveryPassword;
